// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  file_name: yup.string().label("Account import name").required().max(100, "Must be 100 characters or less"),
  description: yup.string().label("Description").required(),
})

export type FormType = yup.InferType<typeof validationSchema>